import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'usableFaxWithExtension',
})
export class UsableFaxWithExtensionPipe implements PipeTransform {
  transform(value: any): any {
    let stringSplit = [];
    stringSplit = value.split(' ');
    const newString = `${stringSplit[0]},${stringSplit[2]}`;
    return newString;
  }
}
